import { render, staticRenderFns } from "./TaxBreakDown.vue?vue&type=template&id=e75a8f8c&scoped=true&"
import script from "./TaxBreakDown.vue?vue&type=script&lang=js&"
export * from "./TaxBreakDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75a8f8c",
  null
  
)

export default component.exports